import PropTypes from "prop-types";
import React from "react";

export const MinusCircleIcon = ({ height, width, ...props }) => {
    return (
        <svg
            viewBox="0 0 1024 1024"
            fill="currentColor"
            height={height || "1em"}
            width={width || "1em"}
            {...props}
        >
            <path d="M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" />
            <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
        </svg>
    );
};

MinusCircleIcon.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number
};
